document.addEventListener("DOMContentLoaded", function () {
  var carouselElements = document.querySelectorAll(".carousel");
  carouselElements.forEach(function (carouselElement) {
    var sliderElement = carouselElement.querySelector(".my-slider");
    if (sliderElement) {
      var sectionId = sliderElement.getAttribute("data-section-id");
      var isAutoPlay = sliderElement.getAttribute("data-section-autoplay");
      var itemsDesktop = sliderElement.getAttribute(
        "data-section-items-desktop"
      );
      var itemsMobile = sliderElement.getAttribute("data-section-items-mobile");
      var itemsTablet = sliderElement.getAttribute("data-section-items-tablet");
      var itemsCenter = sliderElement.getAttribute("data-section-items-center");

      // Convertir la valeur d'autoplay en booléen
      var autoPlayBoolean = isAutoPlay === "true";
      var itemsCenterBoolean = itemsCenter === "true";
      var slider = tns({
        container: ".my-slider-" + sectionId,
        swipeAngle: false,
        items: 5,
        loop: false,
        speed: 400,
        autoplayButtonOutput: false,
        autoplay: autoPlayBoolean,
        prevButton: "#prev-" + sectionId,
        nextButton: "#next-" + sectionId,
        arrowKeys: true,
        mouseDrag: true,
        rewind: true,
        responsive: {
          0: {
            items: parseInt(itemsMobile),
            center: itemsCenterBoolean,
          },
          768: {
            items: parseInt(itemsTablet),
            center: itemsCenterBoolean,
          },
          1024: {
            items: parseInt(itemsDesktop),
            center: itemsCenterBoolean,
          },
          1600: {
            items: parseInt(itemsDesktop),
            center: itemsCenterBoolean,
          },
        },
      });
      console.log(slider);
    }
  });
});
